import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';
import headerObject from '@/types/headerObj';

const endPoint = 'addBotToChannel/';
const url = apiUrl + endPoint;

export interface AddBotToChannelRequest {
  OrgUUID: string;
  ChannelId: string;
}

export interface AddBotToChannelResponse {
  Success: boolean;
  Error: string | null;
}

const addBotToChannel = async (
  req: AddBotToChannelRequest,
  headerObj: headerObject
): Promise<AddBotToChannelResponse | null> => {
  try {
    const res = await postWithAuth(
      url,
      {
        OrgUUID: req.OrgUUID,
        ChannelId: req.ChannelId,
      },
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST,OPTIONS',
          ...headerObj,
        },
      }
    );

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.json();
    const data = JSON.parse(text);
    return data;
  } catch (err) {
    console.error('Error adding bot to channel:', err);
    return null;
  }
};

export default addBotToChannel;
